import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconSpinner({ className }: IconProps): ReactElement {
    return (
        <svg className={className} xmlns='http://www.w3.org/2000/svg'>
            <g fillRule='evenodd' transform='translate(-182.000000, -143.000000)'>
                <g id='MO-spinner-blue' transform='translate(182.000000, 143.000000)'>
                    <path
                        d='M11.5782691,11.0559201 C11.5782691,11.0559201 11.6641199,3.32321773 10.1818089,1.59653133 C8.72026813,-0.101076867 6.9513262,1.262133 7.5349732,2.6869608 C8.04107753,3.92347313 9.14329107,4.1242506 11.5782691,11.0559201'
                        id='Fill-22-path'
                        opacity='0.95'
                    />
                    <path
                        d='M10.9426963,11.7482563 C10.9426963,11.7482563 8.06323253,4.57080747 6.03258413,3.5433806 C4.0323988,2.53395447 2.91980007,4.47041867 4.004705,5.56292513 C4.94560213,6.512118 6.04019987,6.27603133 10.9426963,11.7482563'
                        id='Fill-22-path'
                        opacity='0.9'
                    />
                    <path
                        d='M10.6207557,12.6302925 C10.6207557,12.6302925 5.2128474,7.1019884 2.9440322,6.92959667 C0.7098342,6.76205133 0.423203333,8.977527 1.84320333,9.5715514 C3.07557773,10.0880342 3.99639687,9.45108493 10.6207557,12.6302925'
                        id='Fill-22-path'
                        opacity='0.85'
                    />
                    <path
                        d='M10.6602194,13.5697927 C10.6602194,13.5697927 3.54914187,10.5311293 1.38625547,11.2400815 C-0.741321334,11.9407257 -0.158366667,14.0959681 1.3800244,14.1021991 C2.71694293,14.1077378 3.32343733,13.166853 10.6602194,13.5697927'
                        id='Fill-22-path'
                        opacity='0.8'
                    />
                    <path
                        d='M11.0562409,14.4213661 C11.0562409,14.4213661 3.32343733,14.3355164 1.5967284,15.8178081 C-0.100902,17.2793297 1.26232567,19.0489409 2.68647973,18.4646092 C3.9237006,17.9585115 4.1237884,16.8570047 11.0562409,14.4213661'
                        id='Fill-22-path'
                        opacity='0.75'
                    />
                    <path
                        d='M11.7478937,15.0569307 C11.7478937,15.0569307 4.57173573,17.9370491 3.5429108,19.9676709 C2.5341638,21.9671377 4.47134567,23.0797219 5.56317407,21.9955235 C6.511687,21.0539464 6.27559727,19.9600553 11.7478937,15.0569307'
                        id='Fill-22-path'
                        opacity='0.65'
                    />
                    <path
                        d='M12.6306339,15.3802517 C12.6306339,15.3802517 7.1022574,20.7867046 6.92917113,23.0561825 C6.76231593,25.2896589 8.9778206,25.5769784 9.57185273,24.156997 C10.0883423,22.9239463 9.45069233,22.0038315 12.6306339,15.3802517'
                        id='Fill-22-path'
                        opacity='0.6'
                    />
                    <path
                        d='M13.5694539,15.3400962 C13.5694539,15.3400962 10.5314432,22.4510807 11.2397123,24.6132465 C11.941058,26.7414878 14.0963286,26.1585408 14.1025597,24.6194775 C14.1074061,23.2832687 13.166509,22.6760899 13.5694539,15.3400962'
                        id='Fill-22-path'
                        opacity='0.5'
                    />
                    <path
                        d='M14.4217309,14.9440799 C14.4217309,14.9440799 14.3358801,22.6760899 15.8181911,24.4027763 C17.2797319,26.1003845 19.0486738,24.7371747 18.4650268,23.3130392 C17.9589225,22.0765269 16.8574013,21.8757494 14.4217309,14.9440799'
                        id='Fill-22-path'
                        opacity='0.45'
                    />
                    <path
                        d='M15.0573037,14.2517437 C15.0573037,14.2517437 17.9374598,21.4285002 19.9674159,22.4566194 C21.9676012,23.4653531 23.0801999,21.5295813 21.9959873,20.4370749 C21.0550902,19.4885743 19.9591077,19.7239687 15.0573037,14.2517437'
                        id='Fill-22-path'
                        opacity='0.4'
                    />
                    <path
                        d='M15.3799366,13.3690151 C15.3799366,13.3690151 20.7871526,18.8973193 23.0559678,19.0704033 C25.2901658,19.2372563 25.5767967,17.022473 24.1574891,16.4284486 C22.9244223,15.9112735 22.0036031,16.5489151 15.3799366,13.3690151'
                        id='Fill-22-path'
                        opacity='0.3'
                    />
                    <path
                        d='M15.3397806,12.4302073 C15.3397806,12.4302073 22.4515505,15.4688707 24.6137445,14.7606108 C26.7413213,14.0592743 26.1583667,11.9033395 24.6199756,11.8978009 C23.2837494,11.8922622 22.6765627,12.833147 15.3397806,12.4302073'
                        id='Fill-22-path'
                        opacity='0.2'
                    />
                    <path
                        d='M14.9444515,11.5786339 C14.9444515,11.5786339 22.677255,11.6637913 24.4032716,10.1814995 C26.100902,8.71997793 24.7376743,6.95105913 23.3135203,7.53469847 C22.0762994,8.04148853 21.8755193,9.14299533 14.9444515,11.5786339'
                        id='Fill-22-path'
                        opacity='0.15'
                    />
                    <path
                        d='M14.2521063,10.942377 C14.2521063,10.942377 21.4289566,8.0622586 22.4570892,6.03232907 C23.4658362,4.03216993 21.5293467,2.91958573 20.4368259,4.00378413 C19.488313,4.94536127 19.7244027,6.03994473 14.2521063,10.942377'
                        id='Fill-22-path'
                        opacity='0.1'
                    />
                    <path
                        d='M13.3693661,10.6197483 C13.3693661,10.6197483 18.8977426,5.21260307 19.0708289,2.94381747 C19.2376841,0.710341067 17.0221794,0.4230216 16.4288396,1.84231067 C15.9123501,3.07536133 16.5493077,3.99616847 13.3693661,10.6197483'
                        id='Fill-22-path'
                    />
                    <path
                        d='M11.8974403,1.38052247 C11.9036714,-0.158540801 14.0596343,-0.741487801 14.7602877,1.38675353 C15.4685568,3.54891927 12.4298537,10.6599038 12.4298537,10.6599038 C12.8327987,3.32391007 11.8925939,2.71673127 11.8974403,1.38052247'
                        id='Fill-22-path'
                    />
                </g>
            </g>
        </svg>
    );
}
